import React, { useState, useEffect } from "react"
import { Layout, Menu, Select, Switch, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";


const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const Resources
    = () => {


        const [modal1Open, setModal1Open] = useState(false);
        const [modal2Open, setModal2Open] = useState(false);
        const [modal3Open, setModal3Open] = useState(false);


        const navigate = useNavigate()

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        //   


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Resources</h1>
                            <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                        </div>
                    </div>


                    <section>
                        <div className="slider-section manage-table-data">
                            <div className="slider-tab-div resources-quotes ">

                                <div className="tab-bar">
                                    <Tabs>

                                        <Tabs.TabPane tab="Videos" key="1">

                                            <div className="">
                                                <div class="bg-gradient-primary bott-line   ">
                                                    <input type="text" className="iocn-search  search-bar" placeholder="Search Video" />
                                                </div>

                                                <div className="add-new-widget">
                                                    <div className="widget-grid-sec">
                                                        <div onClick={() => { setModal1Open(true) }} className="create-inner-circle new-wid ">
                                                            <p><span> <img src={images.add} alt="add" /></span>Add new video</p>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>


                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>



                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>


                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>



                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>



                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <video controls>
                                                                    <source src="/video.mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            </div>
                                                            <div className="video-heading">
                                                                <h1>Lorem ipsum </h1>
                                                                <p>Anxiety, Depression <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                            </div>
                                                        </div>





                                                    </div>
                                                </div>



                                            </div>

                                        </Tabs.TabPane>

                                        <Tabs.TabPane tab="Quotes" key="2">
                                            <div className="">
                                                <div class="bg-gradient-primary bott-line   ">
                                                    <input type="text" className="iocn-search  search-bar" placeholder="Search Quotes   " />
                                                </div>

                                                <div className="add-new-widget">
                                                    <div className="widget-grid-sec">
                                                        <div onClick={() => { setModal3Open(true) }} className="create-inner-circle new-wid ">
                                                            <p><span> <img src={images.add} alt="add" /></span>Add new Quote</p>
                                                        </div>

                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />

                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="quotes-section">
                                                            <div className="dummy-quotes">
                                                                <img src={images.quotesBack} alt="quotesBack" />
                                                                <p>Every day is another opportunity to grow and improve.</p>
                                                                <div className="quotes-dots">
                                                                    <img src={images.quotesdots} alt="quotesdots" />
                                                                </div>
                                                            </div>
                                                        </div>







                                                    </div>
                                                </div>



                                            </div>

                                        </Tabs.TabPane>

                                        <Tabs.TabPane tab="Mental Wellness Articles" key="3">
                                            <div className="">
                                                <div class="bg-gradient-primary bott-line   ">
                                                    <input type="text" className="iocn-search  search-bar" placeholder="Search Articles" />
                                                </div>

                                                <div className="add-new-widget">
                                                    <div className="widget-grid-sec">
                                                        <div onClick={() => { setModal2Open(true) }} className="create-inner-circle new-wid ">
                                                            <p><span> <img src={images.add} alt="add" /></span>Add new Article</p>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>


                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>


                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>

                                                        <div className="videos-box">
                                                            <div className="dummy-video">
                                                                <img src={images.cardImage} alt="cardImage" />
                                                            </div>
                                                            <div className="video-heading">
                                                                <p>12 Dec 2023 <span><img src={images.horizontalDots} alt="horizontalDots" /></span></p>
                                                                <h1>Lorem ipsum dolor sit amet, consect adipiscing elit. </h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </Tabs.TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal1Open}
                    closable={true}
                    onCancel={() => setModal1Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Add Videos </h1>
                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.videoTitle}</label>
                                    <Textfiled
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Video Title'
                                    />
                                </div>

                                <div className="form-group">
                                    <label>{appconstant.addTags}</label>
                                    <Textfiled
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Tags'
                                    />
                                </div>


                                <div className="click-to-upload">
                                    <label>Upload Video</label>
                                    <div className="upload-file new-up-file emoji-possible">
                                        <div className="upload-center-text add-widget-activity-x">
                                            <p><span><img src={images.upload} alt="upload" /></span> Click here to upload Video </p>
                                        </div>
                                        <p className="image-disp">File Format: .mp4</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="click-to-upload">
                            <div className="add-activity-button">
                                <button>Upload Video</button>
                            </div>
                        </div>

                    </div>
                </Modal>

                {/* Mental Wellness Articles */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal2Open}
                    closable={true}
                    onCancel={() => setModal2Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Mental Wellness Articles </h1>
                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">
                                <div className="form-group">
                                    <label>{appconstant.emotionTitle}</label>
                                    <Textfiled
                                        className='form-control'
                                        type='text'
                                        placeholder='Enter Emotion Title'
                                    />
                                </div>

                                <div className="form-group">
                                    <div className="textarea-label">
                                        <label>{appconstant.articles}</label>
                                        <p>0/100</p>
                                    </div>
                                    <textarea
                                        rows="5" cols="50"
                                        className='form-control-textarea'
                                        type='textarea'
                                        placeholder='Add Articles here' />
                                </div>
                            </div>
                        </div>


                        <div className="add-sugg-activity">

                            <div className="click-to-upload label-top-space">
                                <label>Upload Background Image</label>
                                <div className="upload-file new-up-file label-less-margin">
                                    <div className="upload-center-text add-widget-activity-x">
                                        <p><span><img src={images.upload} alt="upload" /></span> Click here to upload image</p>
                                    </div>

                                    <p className="image-disp">File Format: .JPEG, .PNG</p>

                                </div>
                            </div>


                        </div>


                        <div className="click-to-upload">
                            <div className="add-activity-button">
                                <button>Upload Article</button>
                            </div>
                        </div>





                    </div>
                </Modal>



                {/* Mental Wellness Articles */}
                <Modal
                    title=""
                    className="modal-update"
                    centered
                    visible={modal3Open}
                    closable={true}
                    onCancel={() => setModal3Open(false)}
                    footer={false}
                    width={600}  >
                    <div className="add-user-popup">
                        <div className="modal-add-user">
                            <h1>Add Quote </h1>
                        </div>

                        <div className="description-inner-circle">
                            <div className="wrapper_line">


                                <div className="form-group">
                                    <div className="textarea-label">
                                        <label>{appconstant.quote}</label>
                                        <p>0/100</p>
                                    </div>
                                    <textarea
                                        rows="5" cols="50"
                                        className='form-control-textarea'
                                        type='textarea'
                                        placeholder='Add Quote here' />
                                </div>
                            </div>
                        </div>


                        <div className="add-sugg-activity">

                            <div className="click-to-upload label-top-space">
                                <label>Upload Background Image</label>
                                <div className="upload-file new-up-file label-less-margin">
                                    <div className="upload-center-text add-widget-activity-x">
                                        <p><span><img src={images.upload} alt="upload" /></span> Click here to upload Image</p>
                                    </div>

                                    <p className="image-disp">File Format: .JPEG, .PNG </p>

                                </div>
                            </div>


                        </div>


                        <div className="click-to-upload">
                            <div className="add-activity-button">
                                <button>Upload Quote</button>
                            </div>
                        </div>





                    </div>
                </Modal>

            </div>

        )
    }
export default Resources

